import React,{useState,useContext,useEffect} from 'react'
import TariffModal from '../../../CommonElements/TariffModal/TariffModal';
import { getAllCarType } from '../../../Services/Car.service';
import CustomTabs from '../../../CommonElements/CommonTabs/CustomTabs';
import CarTypeForm from '../Forms/CarTypeForm';
import CarTypeTable from './CarTypeTable';
import SharedDataContext from '../../../_helper/SharedData';
import { Breadcrumbs,Btn } from '../../../AbstractElements';
import { Plus } from "react-feather";

function CarTypeView() {

    const { globalCityField, setShowApiLoader } = useContext(SharedDataContext);
    const [isSearch, setIsSearch] = useState(true);
    const [isRefresh,setIsRefresh] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [carTypeList, setCarTypeList] = useState([]);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(40);
    const [loader, setLoader] = useState(false);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [carTypeData,setCarTypeData] = useState([])

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };


    useEffect(() => {
      const obj = {
        page:pagination,
        size:rowsPerPage
      }

      getAllCarType(obj).then((resp) => {
        if (resp.status === 200) {
          const data = [];
          resp.data.content.forEach((element) => {
            if(element.name !== "" || element.name !== null){
              
            data.push({
              value: element,
              label: element.name,
              id: element.id,
            });
          }

          });
          setCarTypeList(data);
          setCarTypeData(resp.data.content)
        }
      });
    }, [isRefresh,pagination]);

    const triggerRefresh=()=>{
        setIsRefresh(prev=>!prev);
    }

    const handleCloseModal = () => {
        if(!isSearch){
            setIsSearch(true)
        }else{
          setIsModal(!isModal);
        }
    };

    const tabs = [
        { label: "Car Type", content: <CarTypeForm carTypeList={carTypeList} isSearch={isSearch} setIsSearch={setIsSearch} triggerRefresh={triggerRefresh}/> },
    ];


    
  return (
    <div>
       <Breadcrumbs
          parent="Configuration"
          subParent="Zone"
          mainTitle="Zone"
          span1={
            <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: (e) => setIsModal(true) }}>
              <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
            </Btn>
            }
        />
        {/* Table for CarType */}
        <CarTypeTable
          triggerRefresh={triggerRefresh}
          carTypeData={carTypeData}
          loader={loader}
          setShowApiLoader={setLoader}
          onChangePage={onChangePage}
          paginationPerPage={rowsPerPage}
          paginationTotalRows={paginationTotalRows}
        />
        {/* create flow modal */}

        <TariffModal
        isOpen={isModal}
        size="xl"
        centered
        toggler={handleCloseModal}
        title={"Car Type"}
      >
       {/* <CarTypeFlow carTypeList={carTypeList}/>  */}
       <CustomTabs tabs={tabs}/>
      </TariffModal>

    </div>
  )
}

export default CarTypeView;